import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const style = require('./BuyerNewAccountSetupPage.less');

export default class BuyerNewAccountSetupPage extends React.Component<any, null> {
	render() {
		return (
			<div>
				<Route
					path="/buyer/newAccountSetup"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/buyer/newAccountSetup/association',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
